import React from 'react';
import p11 from '../../img/projects/one/p41.JPG'
import p12 from '../../img/projects/one/p42.JPG'
import Tittle from '../Tittle';

const ProjectsFour = () => {
    const four = {
        id: 4,
        live: 'Live Site',
        title: 'Programmer Team BD',
        link: 'https://elastic-haibt-30dce4.netlify.app/',
        date: '04',
        month: 'Aug',
        year: '2020',
        details: 'Details',
        projects: '/projects4'
    }
    return (
        <div className="container">
            <div classNameName="b-title">
                <Tittle title={four.title} span={four.title} />
            </div>
            <div className='py-5'>
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={p11} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p12} className="d-block w-100" alt="..." />
                        </div>

                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div>
                <div className='row-12'>

                    <p>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={four.link}>{four.live}</a></button>
                    </p>
                    <h1>Project Name :{four.title}</h1>
                </div>
                <div className='row-12'>
                    <ul>
                        <li>It is a Programmer Hire Related responsive website from where someone can Programmer Hire in Developer for any specific Technology Programmer.</li>
                    </ul>
                    <p><strong>Front-end Technology: </strong>HTML5, CSS3, Bootstrap5, javascript. </p>
                </div>
            </div>
        </div>
    );
};

export default ProjectsFour;